import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './MobileHeader.module.scss'
import { useSelector } from 'react-redux'
import { postRequestAsync } from '../../genericAPIs'
import { ReactComponent as Profile } from '../../../assets/images/profile.svg'

const MobileHeader = () => {
  const transactionalData = useSelector((state) => state.common.transactionalData)
  const isTransactionalFlow = transactionalData?.isTransactionalFlow

  const navigate = useNavigate()

  const onNameClick = useCallback(async () => {
    try {
      const response = await postRequestAsync('/coreapi/api/Consumer/resetConsumerProduct', {
        consumerID: +sessionStorage.getItem('consumerID'),
      })
      if (response) {
        await postRequestAsync('/clean_chat', {
          consumerID: +sessionStorage.getItem('consumerID'),
        }, 'chatbot')
      }
    } catch (e) {
      console.log(e)
    }
  }, [])

  return (
    <div className={`justify-between ${styles['header-container']}`}>
      <div className={`${styles['back-and-logo']} d-flex align-center`}>
        <img
          className={`${styles['logo']} header-logo ${isTransactionalFlow ? 'bg-gray' : ''}`}
          src={`/${window.appName}/images/logo.png`}
          onClick={() => {
            navigate('/home')
          }}
          alt='logo'
        />
      </div>
      <Profile className={styles['profile']} onClick={onNameClick} />
    </div>
  )
}

export default MobileHeader
